<template>
  <chat-user :member="source.member"
             :id="source.convId"
             :last-message="source.lastMessage"/>
</template>

<script>
import ChatUser from '@/components/home/chat/ChatUser';

export default {
  name: 'chat-user-wrapper',
  props: {
    source: Object,
  },
  components: {
    ChatUser,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/ChatUserWrapper.vue